
import React, { Component } from "react";
import "./ExperienceCard.css";
import { Fade } from "react-reveal";

class ExperienceCard extends Component {
  render() {
    const experience = this.props.experience;
    const theme = this.props.theme;

    return (
      <Fade bottom duration={2000} distance="40px">
        <div className="experience-card-container">
          {/* Logo positioned outside the card on the left */}
          <div className="experience-card-logo-container">
            <img
              className="experience-card-logo"
              src={require(`../../assets/images/${experience["logo_path"]}`)}
              alt={experience["company"]}
            />
          </div>

          {/* Experience Card */}
          <div className="experience-card" style={{ background: theme.body }}>
            <div className="experience-card-content">
              
              {/* Company Name & Date (Side by Side) */}
              <div className="experience-card-row">
              {/* Date (First Row) */}
              <p className="experience-card-date" style={{ color: theme.secondaryText }}>
                {experience["duration"]}
              </p>

              {/* Company Name (Second Row) */}
              <p className="experience-card-company" style={{ color: theme.text }}>
                <a href={experience["company_url"]} target="_blank" rel="noopener noreferrer">
                  {experience["company"]}
                </a>
              </p>

              {/* Position (Third Row) */}
              <p className="experience-card-position" style={{ color: theme.text }}>
                {experience["title"]}
              </p>

              {/* Location (Fourth Row) */}
              <p className="experience-card-location" style={{ color: theme.secondaryText }}>
                {experience["location"]}
              </p>
            </div>


              {/* Description (Full Width) */}
              {/* Description (Formatted as Bullet Points with Bold Skills) */}
              {Array.isArray(experience["description"]) && experience["description"].length > 0 ? (
                <ul className="experience-card-description" style={{ color: theme.text }}>
                  {experience["description"].map((point, index) => {
                    const trimmedPoint = point.trim();

                    // If the point starts with "Skills:", make it bold and remove bullet point
                    if (trimmedPoint.toLowerCase().startsWith("skills:")) {
                      return (
                        <React.Fragment key={index}>
                          <br /> {/* Adds a space before the skills section */}
                          <li className="experience-card-skills" style={{ listStyleType: "none", fontWeight: "bold" }}>
                            {trimmedPoint.replace("Skills:", "Skills")}
                          </li>
                        </React.Fragment>
                      );
                    }

                    // Render all other points as normal bullet points
                    return trimmedPoint ? <li key={index}>{trimmedPoint}</li> : null;
                  })}
                </ul>
              ) : (
                <p className="experience-card-description" style={{ color: theme.text }}>
                  No description available.
                </p>
              )}


            </div>
          </div>
        </div>
      </Fade>
    );
  }
}

export default ExperienceCard;
